// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    SYSTEM_ALT_LOG_LAST_READING_INFO_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    systemAlertLastReadingInfoResult,
} from 'Redux/actions';

// Helpers
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* getLastReading({ payload }) {
    try {
        
        let QUERY = `
            query getLastReadingJSON ($accountId: Int!, $deviceId: Int!) {
                result: getLastReadingJSON (accountId: $accountId, deviceId: $deviceId)
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(systemAlertLastReadingInfoResult(data?.result))

    } catch (exc) {
        yield put(systemAlertLastReadingInfoResult(null));
        ExceptionManager(exc, 'Modules/accounts/.components/systemAlertLogsTab/.components/lastReadingInfo/redux/saga', 'getLastReading');
    }
}

function* watchMethods() {
    yield takeEvery(SYSTEM_ALT_LOG_LAST_READING_INFO_REQUEST, getLastReading);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}